import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { RsvpListItemProps } from './types';

export const RsvpListItem: React.FC<RsvpListItemProps> = ({ resident }) => {
  const getInitials = (firstName: string, lastName: string) => {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  };

  const accessibilityLabel = `${resident.firstName} ${resident.lastName}, ${resident.email}${resident.unitNumberSpace ? `, Unit ${resident.unitNumberSpace}` : ''}, RSVP confirmed`;

  return (
    <TouchableOpacity 
      style={styles.rsvpListItem} 
      activeOpacity={0.7}
      accessibilityLabel={accessibilityLabel}
      accessibilityHint="RSVP list item"
      accessibilityRole="button"
    >
      <View style={styles.avatarContainer}>
        <Text style={styles.avatarText}>
          {getInitials(resident.firstName, resident.lastName)}
        </Text>
      </View>
      <View style={styles.rsvpListItemContent}>
        <Text style={styles.rsvpListItemName}>
          {resident.firstName} {resident.lastName}
        </Text>
        <Text style={styles.rsvpListItemEmail}>{resident.email}</Text>
        {resident.unitNumberSpace && (
          <View style={styles.unitBadge}>
            <Text style={styles.unitBadgeText}>Unit {resident.unitNumberSpace}</Text>
          </View>
        )}
      </View>
      <View style={styles.rsvpStatus}>
        <View style={styles.rsvpStatusDot} />
        <Text style={styles.rsvpStatusText}>RSVP'd</Text>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  rsvpListItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 16,
    paddingHorizontal: 16,
    marginBottom: 8,
    backgroundColor: ADMIN_COLORS.DATA_TABLE.BACKGROUND,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER + '30',
  },
  avatarContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: ADMIN_COLORS.PRIMARY + '20',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  avatarText: {
    fontSize: 16,
    fontWeight: '700',
    color: ADMIN_COLORS.PRIMARY,
  },
  rsvpListItemContent: {
    flex: 1,
  },
  rsvpListItemName: {
    fontSize: 16,
    fontWeight: '600',
    color: ADMIN_COLORS.TEXT_PRIMARY,
    marginBottom: 4,
  },
  rsvpListItemEmail: {
    fontSize: 14,
    color: ADMIN_COLORS.TEXT_SECONDARY,
    marginBottom: 6,
  },
  unitBadge: {
    alignSelf: 'flex-start',
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 4,
  },
  unitBadgeText: {
    fontSize: 12,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT_TERTIARY,
  },
  rsvpStatus: {
    alignItems: 'center',
  },
  rsvpStatusDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: ADMIN_COLORS.SUCCESS,
    marginBottom: 4,
  },
  rsvpStatusText: {
    fontSize: 10,
    fontWeight: '500',
    color: ADMIN_COLORS.SUCCESS,
    textTransform: 'uppercase',
  },
});
